class DataRegister {

    static api = {
        url: 'https://formspree.io/mjorpewx',
    };

    static setMessage(email, phone, message){
        return new Promise(function(resolve, reject) {
            let data = {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: "name="+phone+"&email="+email+"&message="+message
            };
            fetch(DataRegister.api.url, data)
            .then((response) => response.json())
            .then((responseJson) => {
                resolve(responseJson);
            })
            .catch(error => {
                resolve(error);
            });
        });
    }

    static message(email, phone, message) {
        return DataRegister.setMessage(email, phone, message);
    }

}

export { DataRegister }


// WEBPACK FOOTER //
// ./src/services/DataRegister.js